<template>
  <svg
    :class="size"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.56636 1.19481C8.56309 0.198083 10.1791 0.198083 11.1758 1.19481C12.1382 2.15717 12.1714 3.69685 11.2754 4.69902L11.1758 4.80429L10.5092 5.47095L4.17583 11.8043C4.07164 11.9085 3.93652 11.9746 3.79206 11.9938L3.70443 11.9995H1.03776C0.69587 11.9995 0.414089 11.7422 0.375579 11.4106L0.371094 11.3329V8.66622C0.371094 8.51888 0.41987 8.37656 0.508481 8.26086L0.566356 8.19481L6.89913 1.86204C6.89931 1.86185 6.8995 1.86167 6.89969 1.86148C6.89988 1.86129 6.90006 1.8611 6.90025 1.86092L7.56636 1.19481ZM7.37108 3.27568L1.70443 8.94222V10.6656H3.42776L9.09485 4.99945L7.37108 3.27568ZM10.0377 4.05672L8.3139 2.33288L8.50916 2.13762L8.59114 2.06269C9.07004 1.66306 9.78344 1.68804 10.233 2.13762L10.308 2.2196C10.7076 2.69849 10.6826 3.4119 10.233 3.86148L10.0377 4.05672Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: () => '#979797'
    },
    size: {
      type: String,
      default: () => 'h-4 w-4'
    }
  }
}
</script>
